import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Autore antico',
  bodyClasses: 'occurrences-style',
  tabs: 'ancient_author',
  type: 'ancient_author',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'tab-bar',
        type: 'tabs'
      }
    ],
    content: [
      {
        id: 'metadata-occurrences',
        type: 'metadata',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
